import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IPackageCard } from '../../../Pages/PackageManagement/IPacakageManagement';

export const AddPackageSlicer = createSlice({
  name: 'AddPackage',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IPackageCard>,
  reducers: {
    addPackage: (state, _) => {
      state.isLoading = true;
    },
    successAddPackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddPackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddPackageState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addPackage,
  successAddPackage,
  failureAddPackage,
  clearAddPackageState,
} = AddPackageSlicer.actions;

export default AddPackageSlicer.reducer;
